import { Link, useNavigate } from "react-router-dom";
import { CalendarRange, Copy } from "lucide-react";
import { useI18n } from "../../../i18n";
import { useCart } from "../../../context/CartContext";
import { fmtDate } from "../../../lib/format";
import { usePreseason } from "../hooks";
import { reorderInto } from "../reorder";

export const PreseasonCard = ({ shop, enabled }) => {
  const { t } = useI18n();
  const cart = useCart();
  const nav = useNavigate();
  const q = usePreseason(enabled);
  const d = q.data;
  if (!d?.active || !d.lines.length) return null;
  const sellable = d.lines.filter((l) => shop.priceMap[l.item_code]);
  return (
    <section data-testid="preseason-card" className="relative overflow-hidden rounded-2xl border-2 border-brand bg-white p-5 animate-in fade-in slide-in-from-bottom-2 duration-500">
      <CalendarRange className="pointer-events-none absolute right-4 top-4 h-14 w-14 text-brand/10" />
      <h2 className="text-base font-semibold text-navy md:text-lg">{t("preseason.title")}</h2>
      <p className="mt-1 max-w-lg text-sm text-slate-600">{t("preseason.sub", { from: fmtDate(d.season_from), to: fmtDate(d.season_to) })}</p>
      <p className="mt-2 text-xs font-medium text-slate-500" data-testid="preseason-summary">{t("preseason.summary", { n: sellable.length, o: d.orders })}</p>
      <button type="button" disabled={!sellable.length} data-testid="preseason-copy-button"
        onClick={() => reorderInto(cart, d.lines, shop, t) && nav("/app/cart")}
        className="mt-4 flex h-12 items-center gap-2 rounded-full bg-brand px-5 text-sm font-semibold text-white transition-transform duration-150 active:scale-95 disabled:opacity-50">
        <Copy className="h-4 w-4" /> {t("preseason.button")}
      </button>
      <Link to="/app/cart" className="sr-only">{t("shop.cart")}</Link>
    </section>
  );
};
